import { Box, Typography } from "@mui/material";
import Lottie from "react-lottie";
import { assets } from "../../../../assets";
import { colors } from "../../../ui/colors";

/**
 * TodayJobsPlaceholder Component
 *
 * Displays an empty state with a Lottie animation when no jobs are available.
 * Maintains consistent height (300px) to prevent layout shifts when toggling
 * between empty and populated states.
 */ export const lottieOptions = {
  loop: true,
  autoplay: true,
  animationData: assets.animation.noDataJobsNew,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid meet",
  },
};
export const TodayJobsPlaceholder = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: { xs: "center", sm: "start" },
        minHeight: 0,
        py: 1,
      }}
    >
      <Lottie options={lottieOptions} height={100} width={100} isClickToPauseDisabled />
      <Typography
        variant="caption"
        sx={{
          color: colors.gray[400],
          fontWeight: 500,
          fontSize: "0.75rem",
          mt: 1,
        }}
      >
        No jobs assigned
      </Typography>
    </Box>
  );
};
